import React from 'react'
import { MdOutlineArrowLeft } from "react-icons/md";


const Nonvegetarian = () => {
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap w-full mb-20">
            <div class="lg:w-1/2 w-full mb-6 lg:mb-0">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Nonvegetarian Cuisines
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/menu">
                  <p className="text-blue-700">Back</p>
                </a>
              </div>
            </div>
            {/* <p class="lg:w-1/2 w-full leading-relaxed text-gray-500">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p> */}
          </div>
          <div class=" tourney lg:grid lg:grid-cols-6 grid grid-cols-2  -m-4 mx-2 mt-0.5 text-center   ">
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHICKEN BIRYANI.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHICKEN BIRYANI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHICKEN DONNE BIRYANI.avif"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHICKEN DONNE BIRYANI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\HYDERABADI DUM BIRYANI.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  HYDERABADI DUM BIRYANI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\MUTTON BIRYANI.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  MUTTON BIRYANI
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\BUTTER CHICKEN.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  BUTTER CHICKEN
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\TANDOORI CHICKEN.avif"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  TANDOORI CHICKEN
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\GUNTOOR CHICKEN.gif"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  GUNTOOR CHICKEN
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHICKEN CURRY.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHICKEN CURRY
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\MUTTON CURRY.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  MUTTON CURRY
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\FISH CURRY.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  FISH CURRY
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\ALOO GOSHT.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  ALOO GOSHT
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\KEEMA PARATHA.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  KEEMA PARATHA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\MUTTON KOFTA.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  MUTTON KOFTA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHICKEN KOFTA.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHICKEN KOFTA
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHICKEN KEBAB.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHICKEN KEBAB
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\PUDINA KEBAB.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  PUDINA KEBAB
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\FISH KEBAB.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  FISH KEBAB
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHICKEN FRY.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHICKEN FRY
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\PEPPER DRY CHICKEN.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  PEPPER DRY CHICKEN
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\LEMON CHICKEN.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  LEMON CHICKEN
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHICKEN MANCHURIAN.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHICKEN MANCHURIAN
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\CHILLI CHICKEN.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHILLI CHICKEN
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\BOTI CURRY.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  BOTI CURRY
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Nonvegetarian\BOTI FRY.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  BOTI FRY
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Nonvegetarian